import React from 'react'
import Navbar from '../../components/navbar'
import bg1 from '../../assets/images/bg.jpg'
import { Link } from 'react-router-dom'
import Shape from '../../components/shape'
import ShapeTwo from '../../components/shape-two'
import Footer from '../../components/footer'

export default function PageSignup() {
  return (
    <>
     <Navbar/> 

    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'cemter'}}>
        <div className="bg-overlay bg-overlay-white"></div>
        <div className="container">
            <div className="row mt-5 text-center align-items-center">
                <div className="col-sm-6">
                    <div className="text-sm-start">
                        <div className="page-next-level">
                            <h4 className="title">Signup</h4>
                            <p className="text-muted mb-0">Fillup your personal details and register your private account</p>                                        
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <div className="page-next-level text-sm-end">
                        <ul className="page-next ps-0 mb-0">
                            <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                            <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Pages</Link></li>
                            <li className="list-inline-item"><Link href="#" className="text-uppercase fw-bold text-dark">Authentication</Link></li>
                            <li className="list-inline-item">
                                <span className="text-uppercase text-primary fw-bold">Signup</span> 
                            </li> 
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <ShapeTwo/>

    <section className="section">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-5 col-md-8">
                    <div className="login_page">
                        <form className="login-form">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="mb-3">                                               
                                        <label className="form-label">First name <span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" placeholder="First Name" name="s" required=""/>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="mb-3">                                                
                                        <label className="form-label">Last name <span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" placeholder="Last Name" name="s" required=""/>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label className="form-label">Email <span className="text-danger">*</span></label>
                                        <input type="email" className="form-control" placeholder="Email" name="email" required=""/>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label className="form-label">Password <span className="text-danger">*</span></label>
                                        <input type="password" className="form-control" placeholder="Password" required=""/>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label className="form-label">Confirm Password <span className="text-danger">*</span></label>
                                        <input type="password" className="form-control" placeholder="Confirm Password" required=""/>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                            <label className="form-check-label" htmlFor="flexCheckDefault">I Accept <Link to="#" className="text-primary">Terms And Condition</Link></label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <button className="btn btn-primary w-100">Register</button>
                                </div>
                                <div className="mx-auto">
                                    <p className="mb-0 mt-4"><small className="text-dark me-2">Already have an account ?</small> <Link to="/page-login" className="text-dark fw-bold">Sign in</Link></p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
